import NavigateBack from "../../components/navigateBack";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
import LatestPx from "./latestPx";
import PreviousPx from "./previousPx";
import createPersistedState from "use-persisted-state";

//TODO: Copied from myReports, refactor this to avoid duplication
const useStyles = makeStyles((theme) => ({
  selectedTab: {
    backgroundColor: "#0e426a",
    height: 50,
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  unselectedTab: {
    backgroundColor: "#97d1fa57",
    height: 50,
    color: "#0060a6b3",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

function MyPrescriptionsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = React.useState(0);
  const classes = useStyles();
  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [isLoading, setIsLoading] = useState(true);
  const [px, setPx] = useState(undefined);

  const [complaintsSentence, setComplaintsSectence] = useState("");
  const [assessmentScoresSentence, setAssessmentScoresSentence] = useState("");
  const [findingsSentence, setFindingsSentence] = useState("");

  // If noPx is true that means patient hasn't received
  // any px from Doctor yet.
  const [noPx, setNoPx] = useState(false);
  const getPrescriptionUrl = (pId) => `/api/v1/users/prescriptions/${pId}`;

  const getComplaintsSentenceUrl = () => `/api/v1/users/complaints/chips/text`;

  const fetchComplaintsSentence = async (
    complaintChips,
    findingsList,
    token
  ) => {
    const payload = {
      complaints: complaintChips?.complaints,
      customNote: complaintChips?.customNote,
      findings: findingsList,
    };

    try {
      const response = await fetch(getComplaintsSentenceUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();
      if (responseData["status"]["success"]) {
        setComplaintsSectence(responseData?.["combinedText"] || ""); // Assuming 'combinedText' is the key in the response
        setAssessmentScoresSentence(responseData?.["assessmentText"] || ""); // Assuming 'assessmentScoresText' is the key in the response
        setFindingsSentence(responseData?.["findingText"] || ""); // Assuming 'findingsText' is the key in the response
      } else {
        console.log("Failed to fetch complaints sentence"); // TODO: Handle error
      }
    } catch (e) {
      console.log(e.message); // TODO: Report error
    }
  };

  const fetchPx = async (pId, token) => {
    setIsLoading(true); // Start loading state
    try {
      const response = await fetch(getPrescriptionUrl(pId, token), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      const responseData = await response.json();
      if (responseData["status"]["success"]) {
        setPx(responseData);
        setNoPx(responseData["prescription"] == null);

        // Check conditionally for complaintChips and fetch the second API
        if (responseData["prescription"]?.complaintChips) {
          await fetchComplaintsSentence(
            responseData["prescription"].complaintChips,
            responseData["prescription"]?.noteChips?.findings,
            token
          );
        }
      } else {
        setNoPx(false);
      }
    } catch (e) {
      console.log(e.message); // TODO: Report error
    } finally {
      setIsLoading(false); // End loading state
    }
  };

  useEffect(() => {
    if (pid && token) {
      fetchPx(pid, token); // TODO: Fetch docId from localStorage
    } // TODO: Else report error
  }, [pid, token]);

  return (
    <>
      <NavigateBack title={t("px.title")} />
      <div style={{ marginTop: "78px" }}>
        <Grid container spacing={0}>
          <Grid item xs={6}>
            <Container
              maxWidth="sm"
              disableGutters
              onClick={() => {
                setTab(0);
              }}
            >
              <Typography
                component="div"
                className={
                  tab === 0 ? classes.selectedTab : classes.unselectedTab
                }
              >
                {t("px.latest")}
              </Typography>
            </Container>
          </Grid>
          <Grid item xs={6}>
            <Container
              maxWidth="sm"
              disableGutters
              onClick={() => {
                setTab(1);
              }}
            >
              <Typography
                component="div"
                className={
                  tab === 1 ? classes.selectedTab : classes.unselectedTab
                }
              >
                {t("px.previous")}
              </Typography>
            </Container>
          </Grid>
        </Grid>
      </div>
      {tab === 0 ? (
        <LatestPx
          isLoading={isLoading}
          patientPx={px}
          complaints={complaintsSentence}
          assessmentScoresSentence={assessmentScoresSentence}
          findingsSentence={findingsSentence}
          shouldBookAppointment={noPx}
        />
      ) : (
        <PreviousPx isLoading={isLoading} patientPx={px} />
      )}
    </>
  );
}

export default MyPrescriptionsPage;
